import React, { useState } from 'react';
import { FiPlus, FiX } from 'react-icons/fi';
import { toast } from 'react-toastify';

import { createNewProfile } from '../../api/profile';
import { ChartType } from '../../types/chartTypes';
import { ICreateProfilePayload, IProfile } from '../../types/Profile';
import { Button } from '../Button/Button';
import CreateProfileForm from '../CreateProfileForm';
import Modal from '../Modal';
import PersonalContentNav from '../Nav';
import { ProfileActionPanel } from '../ProfileActionPanel/ProfileActionPanel';
import { useAuth } from '../../contexts/AuthContext';
import { formatDate } from '../../utils/dateUtils';

import styles from './ControlPanel.module.scss';

interface ControlPanelProps {
  activeProfile: IProfile;
  activeChart: ChartType;
  handleChartChange: (chartKey: ChartType) => void;
}

export function ControlPanel({ activeProfile, activeChart, handleChartChange }: ControlPanelProps) {
  const { setProfile, switchProfile, profiles, isAuthenticated } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleSubmit = async (payload: ICreateProfilePayload) => {
    try {
      const profile = await createNewProfile(payload);
      await setProfile(profile);
      toast.success('Профиль создан');
    } catch {
      toast.error('Ошибка создания профиля. Попробуйте позже.');
    } finally {
      closeModal();
    }
  };

  return (
    <div className={styles.controlPanel}>
      <PersonalContentNav activeChart={activeChart} onChange={handleChartChange} />
      <div className={styles.profileActions}>
        <ProfileActionPanel
          profiles={profiles}
          onSelect={switchProfile}
          label={`${activeProfile.firstName} ${activeProfile.lastName} [ ${formatDate(activeProfile.bornAt)} ]`}
        />
        {isAuthenticated && (
          <>
            <Button onClick={openModal} className={styles.profileActions__button}>
              <FiPlus />
              НОВЫЙ ПРОФИЛЬ
            </Button>
            <Modal isOpen={isModalOpen} onRequestClose={closeModal} contentLabel="Создать профиль">
              <CreateProfileForm
                styles={styles.form}
                onSubmit={handleSubmit}
                header={
                  <>
                    <div className={styles.formHeader_title}>ДОБАВИТЬ НОВЫЙ ПРОФИЛЬ</div>
                    <Button className={styles.formHeader_closeButton} type="button" variant="text" onClick={closeModal}>
                      <FiX />
                    </Button>
                  </>
                }
              />
            </Modal>
          </>
        )}
      </div>
    </div>
  );
}
